export const BASE_URL = 'https://instamenu-ap-graphql-xfbjqvk7o.herokuapp.com/graphql';
